<template>
    <div class="left-pane">
        <div class="all-options">
            <div v-if="optionsToProvide.ALL" role="tablist">
                <b-card no-body class="accordion b-card mb-1">
                    <b-card-header header-tag="header" class="accordion-header" role="tab">
                        <b-button class="btn-sm accordion-toggle-btn" block v-b-toggle.accordion1>הגדרות ניקוד
                            <div class="when-closed"><i-caret-up></i-caret-up></div>
                            <div class="when-opened"><i-caret-down></i-caret-down></div>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion1" accordion="settings" role="tabpanel">
                        <div class="accordion-body">
                            <ul class="chapter1 list-unstyled accordion-list">
                                <p class="accordion-body-heading">דלג על הניקוד באפשרויות הבאות</p>
                                <li>
                                    <b-form-checkbox dir="rtl" v-model="options.skipLetters"> אות בודדת
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.skipAbbrevs">
                                        ראשי תיבות
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox
                                            @change="skipAllSurroundersClicked"
                                            :checked="skipAllSurrounders"
                                            :indeterminate="skipSomeSurrounders">
                                        סוגריים
                                        <span @click.prevent="showAllSkipSurrounders = !showAllSkipSurrounders">
                                            <i-caret-down v-show="!showAllSkipSurrounders" />
                                            <i-caret-up v-show="showAllSkipSurrounders" />
                                        </span>
                                    </b-form-checkbox>
                                    <ul v-show="showAllSkipSurrounders" class="section1 accordion-inner-ul">
                                        <li>
                                            <b-form-checkbox v-model="options.skipParens">
                                                עגולים ()
                                            </b-form-checkbox>
                                        </li>
                                        <li>
                                            <b-form-checkbox v-model="options.skipBrackets">
                                                מרובעים []
                                            </b-form-checkbox>
                                        </li>
                                        <li>
                                            <b-form-checkbox v-model="options.skipBraces">
                                                מסולסלים {}
                                            </b-form-checkbox>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.skipVoc">
                                        מילה מנוקדת
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.skipPartVoc">
                                        מילה מנוקדת חלקית
                                    </b-form-checkbox>
                                </li>
                                <hr class="my-2"/>
                                <p class="accordion-body-heading">הגדרות נוספות</p>
                                <li>
                                    <b-form-checkbox v-model="options.splitParens">
                                        פצל מילה עם סוגריים <span id="special-popover"><i class="fa fa-info-circle mr-1"></i></span>
                                    </b-form-checkbox>
                                    <b-popover target="special-popover" container="" placement="top" triggers="hover focus" :content="SplitWordParenthesesTipText">
                                    </b-popover>

                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.dageshOnlyIfHeard">
                                        השמט דגשים שאינם נשמעים<span id="special-popover-2"><i class="fa fa-info-circle mr-1"></i></span>
                                    </b-form-checkbox>
                                    <b-popover target="special-popover-2" container="" placement="top"  triggers="hover focus" :content="OmittingEmphasesTipText">
                                    </b-popover>
                                </li>
                                <hr class="my-2"/>
                                <p class="accordion-body-heading">כללי ניקוד</p>
                                <li>
                                    <b-form-checkbox v-model="options.ketivMaleh">
                                        ניקוד בכתיב מלא 
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.useQamatzQatan">
                                        ניקוד בקמץ קטן 
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.keepSourceDagesh">
                                        השמטת דגש כבמקורות <span id="special-popover-3"><i class="fa fa-info-circle mr-1"></i></span>
                                    </b-form-checkbox>
                                    <b-popover target="special-popover-3" container="" placement="top" triggers="hover focus" :content="KeepSourceDageshTipText">
                                    </b-popover>
                                </li>
                                <li>
                                    <b-form-checkbox v-model="options.mahPatachDagesh">
                                        ניקוד "מה" בפתח+דגש 
                                    </b-form-checkbox>
                                </li>
                            </ul>
                        </div>
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion b-card mb-1">
                    <b-card-header header-tag="header" class="accordion-header" role="tab">
                        <b-button class="btn-sm accordion-toggle-btn" block v-b-toggle.accordion2>סגנון טקסט
                            <div class="when-closed"><i-caret-up></i-caret-up></div>
                            <div class="when-opened"><i-caret-down></i-caret-down></div>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion2" accordion="settings" role="tabpanel">
                        <b-card-body class="accordion-body">
                            <document-settings-genre :options="options" />
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion b-card mb-1">
                    <b-card-header header-tag="header" class="accordion-header" role="tab">
                        <b-button class="btn-sm accordion-toggle-btn" block v-b-toggle.accordion3>
                            <div>מסלול ניקוד</div>
                            <div class="when-closed"><i-caret-up></i-caret-up></div>
                            <div class="when-opened"><i-caret-down></i-caret-down></div>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion3" accordion="settings" role="tabpanel">
                        <b-card-body class="accordion-body">
                            <ul class="chapter2 list-unstyled accordion-list">
                                <li @click="options.nikudType='auto'">
                                    <b-form-radio id="use-auto-nikud" value="auto" v-model="options.nikudType">
                                        החל ניקוד על הטקסט
                                    </b-form-radio>
                                    <div class="frame nikud-setting-des">הנקדן יחיל על הטקסט ניקוד אוטומטי. במעבר על
                                        המילה, הנקדן יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני.
                                    </div>
                                </li>
                                <li @click="options.nikudType='manual'">
                                    <b-form-radio id="use-manual-nikud" value="manual" v-model="options.nikudType">
                                        השאר את הטקסט ללא ניקוד
                                    </b-form-radio>
                                    <div class="frame nikud-setting-des">לא יוחל ניקוד על הטקסט. במעבר על המילה, הנקדן
                                        יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני.
                                    </div>
                                </li>
                            </ul>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <document-settings-genre v-if="optionsToProvide.ONLY_GENRE" :options="options" />
        </div>
        <nakdan-runner :options="options" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import serviceMixins from '@/mixins/serviceMixins'
    import DocumentSettingsGenre from './DocumentSettingsGenre'
    import NakdanRunner from './NakdanRunner'
    import {SimpleVsProConfig} from '@/simpleVsProConfig.js'

    const autoNikudDescription = 'הנקדן יחיל על הטקסט ניקוד אוטומטי. במעבר על המילה, הנקדן יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני. '
    const manualNikudDescription = 'לא יוחל ניקוד על הטקסט. במעבר על המילה, הנקדן יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני.'
    const SplitWordParentheses = 'מילה מפוצלת, מתייחסת אל המילה שבסוגריים כאל יחידה עצמאית.\n לדוגמא שומר[ות] - שומר, ות.'
    const OmittingEmphases = 'הנקדן יציג דגשים רק עבור האותיות בהם הדגש נשמע (ב, כ, פ)'
    const KeepSourceDagesh = 'השמטת הדגש במ\' שוואית אחרי יידוע'

    export default {
        name: 'DocumentSettings',
        components: {
            DocumentSettingsGenre,
            NakdanRunner
        },
        mixins: [serviceMixins], // for gtag()
        data() {
            return {
                showTextTooLongPrompt: false,
                options: JSON.parse(JSON.stringify(this.$store.state.preSubmissionOptions)),
                // data items below here are used only by the 'Pro' Nakdan
                showAllSkipSurrounders: false,
                autoNikudToolTipText: autoNikudDescription,
                manualNikudToolTipText: manualNikudDescription,
                SplitWordParenthesesTipText: SplitWordParentheses,
                OmittingEmphasesTipText: OmittingEmphases,
                KeepSourceDageshTipText: KeepSourceDagesh
            }
        },
        computed: {
            optionsToProvide () {
                return SimpleVsProConfig.PRE_SUBMISSION_OPTIONS_TO_PROVIDE
                // copied from SimpleVsProConfig.js: ONLY_GENRE: NakdanType.Simple, ALL: NakdanType.Pro
            },
            // computed properties below here are used only by the 'Pro' Nakdan
            skipAllSurrounders() {
                return this.options.skipBraces && this.options.skipParens && this.options.skipBrackets
            },
            skipSomeSurrounders() {
                return !(this.skipAllSurrounders) && (this.options.skipBraces || this.options.skipParens || this.options.skipBrackets)
            }
        },
        methods: {
            skipAllSurroundersClicked() { // used only by the 'Pro' Nakdan
                const setTo = !this.skipAllSurrounders
                this.options.skipBraces = setTo
                this.options.skipParens = setTo
                this.options.skipBrackets = setTo
            }
        }
    }
</script>

<style scoped>
    /* DocumentSettings-specific CSS goes here */
    /*only of this page*/
    .left-pane {
        text-align: right;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        margin-right: 12px;
    }

    .left-pane .all-options {
        flex: auto;
        overflow: auto;
    }

    /* settings below here are used, in this component (as opposed to its "child"), only by the 'Pro' Nakdan */
    .accordion-list {
        margin: 0 10px;
        padding: 0;
    }

    .accordion-body-heading {
        margin: 0 0 5px;
    }

    /* settings below here are used only by the 'Pro' Nakdan */
    .accordion-body .accordion-body-heading {
        font-size: 13px;
    }

    .accordion-body {
        padding: 10px 0;
    }

    .accordion {
        background: transparent;
        border: none;
    }

    .accordion-inner-ul {
        margin: 5px 20px 5px 10px;
        padding: 0;
        list-style: none;
    }

    .nikud-setting-des {
        font-size: 13px;
        padding: 10px;
        margin-bottom: 15px;
        margin-top: 8px;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>
